import { useAppStore } from "@/stores/app";
import { useApiClient } from "./useApiClient";

export type BrandParameters = {
  id: number;
  color: string;
  numberOfTutorialSteps: number;
  texts: Record<string, Object>;
};

async function fetchBrandParameters(): Promise<BrandParameters | null> {
  const apiClient = useApiClient();
  try {
    const { data } = await apiClient.getBrandParameters();
    if (data && data.color && data.color['label-color']) {
      document.documentElement.style.setProperty('--label-color', data.color['label-color']);
    }
    return data;
  } catch (error) {
    console.error("Error fetching brand parameters:", error);
    return null;
  }
}

export const useBrandParameters = async () => {
  const appStore = useAppStore();
  const brandParameters = await fetchBrandParameters();
  appStore.setNumberOfTutorialSteps(brandParameters?.numberOfTutorialSteps);
  appStore.setTexts(brandParameters?.texts);
  appStore.setParameters(brandParameters);

  return {
    id: brandParameters?.id,
    defaultTheme: brandParameters?.color,
    numberOfTutorialSteps: brandParameters?.numberOfTutorialSteps,
  }
}
